<template>
  <div class="main">
    <div class="title-bar">
      <h1>Reset Your Password</h1>
    </div>
    <div class="container">
      <FormWrapper method="POST" :action="route('password.update')">
        <slot name="token" />
        <transition name="fade">
          <Alert v-if="hasAlert" :alert="alert" class="text-center" />
        </transition>
        <div class="row">
          <div class="col-12 mb-3">
            <Field
              type="text"
              label="Email"
              name="email"
              :value="email"
              validate="required"
            />
          </div>
          <div class="col-12 mb-3">
            <Field
              type="password"
              label="New Password"
              name="password"
              value=""
              validate="required"
            />
          </div>
          <div class="col-12 mb-3">
            <Field
              type="password"
              label="Confirm Password"
              name="password_confirmation"
              value=""
              validate="required"
              validate-as="password confirmation"
            />
          </div>
          <div class="col-12 text-center">
            <button type="submit" class="btn btn-primary">Reset Password</button>
          </div>
        </div>
      </FormWrapper>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    email: { type: String, default: "" }
  }
};
</script>

<style scoped>
.container {
  max-width: 576px;
}
</style>